import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Page } from '../../components';
import { ReactComponent as NotFound } from '../../assets/images/errors/404-page.svg';
import { ReactComponent as ServerError } from '../../assets/images/errors/500-page.svg';
import { ReactComponent as BadGateway } from '../../assets/images/errors/502-error.svg';
import { ReactComponent as ForbiddenError } from '../../assets/images/errors/403-page.svg';
import history from '../../helpers/history';
import { ReactComponent as Logo } from '../../assets/images/Logo-Protean.svg';
import { getFirstEntry } from '../../helpers';

const errors = {
  404: {
    title: '404 Page not found',
    image: <NotFound />
  },
  403: {
    title: '403 Forbidden',
    image: <ForbiddenError />
  },
  500: {
    title: 'Internal Server Error',
    image: <ServerError />
  }
};

const Base = ({ children }) => <div className="error-page">{children}</div>;

Base.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

// eslint-disable-next-line
const ErrorTableBlock = ({ code }) => (
  <>
    <h1>{errors[code]?.title || 'Unexpected error'}</h1>
    {errors[code]?.image || <BadGateway />}
  </>
);

// eslint-disable-next-line
const ErrorBlock = ({ code }) => (
  <Base>
    <h1>{errors[code]?.title || 'Unexpected error'}</h1>
    {errors[code]?.image || <BadGateway />}
    <button
      className="protean-btn protean-btn-default"
      type="button"
      onClick={() => history.push(getFirstEntry())}
    >
      Back to home
    </button>
  </Base>
);

// eslint-disable-next-line
const ErrorPageNoneAuth = ({ code }) => (
  <div className="nonAuthBlock">
    <div className="logo">
      <Logo className="logo" />
    </div>
    <div className="error-block">
      <ErrorBlock code={code} />
    </div>
  </div>
);

// eslint-disable-next-line
const ErrorPage = ({ code }) => {
  useEffect(() => {
    document.getElementById('protean-footer').classList.add('mt-0');
    return () => {
      document.getElementById('protean-footer')?.classList?.remove('mt-0');
    };
  }, []);
  return (
    <Page path="404" pageName="404" documentName="404">
      <ErrorBlock code={code} />
    </Page>
  );
};

export { ErrorPage as default, ErrorPageNoneAuth, ErrorBlock, ErrorTableBlock };
